import Faq from "../FAQ/faq";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/contact");
  };

  return (
    <div>
      <section className="relative overflow-hidden bg-brand-dark-blue text-white">
        <div className="max-w-7xl mx-auto pt-10 md:pt-24 pb-10 md:pb-14 px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-12 items-center gap-6 md:gap-12">
            <div className="md:col-span-6">
              <h1 className="font-bold tracking-tight leading-[1.2] text-3xl sm:text-4xl md:text-6xl lg:text-7xl whitespace-normal">
                Powering a Sustainable Future with Solar, EV &amp; Smart Energy Solutions
              </h1>
            </div>

            <div className="md:col-span-6 flex justify-center md:justify-end mt-6 md:mt-0">
              <img
                src="/home-house-banner.png"
                alt="Solar EV Smart Energy House"
                className="w-full max-w-[400px] sm:max-w-[600px] md:max-w-[760px] lg:max-w-[880px] h-auto md:translate-y-2 lg:translate-y-3 -mr-0 md:-mr-2 lg:-mr-6"
              />
            </div>
          </div>

          <div className="mt-8 md:mt-14">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-6">
              <p className="text-white/80 text-base sm:text-lg md:text-xl max-w-full md:max-w-3xl">
                Comprehensive energy solutions for homes, businesses, and communities
                that save costs and reduce carbon footprint.
              </p>

              <button
                onClick={handleClick}
                className="inline-flex items-center justify-center gap-2 bg-brand-green text-white font-medium 
             px-4 py-2 text-sm sm:px-5 sm:py-3 sm:text-base 
             rounded-md shadow-md hover:opacity-90 transition mx-auto md:mx-0"
              >
                Get Your Free Consultation
                <span aria-hidden>→</span>
              </button>

            </div>
          </div>
        </div>
      </section>

      <section className="bg-slate-50 py-16 md:py-24">
        <div className="mx-auto max-w-[200px] md:max-w-none px-4 md:px-8">
          <h2 className="text-3xl md:text-5xl tracking-tight text-slate-900 text-left md:ml-32">
            Our Solutions Overview:
          </h2>

          <div className="mt-12 flex flex-wrap justify-center gap-8 md:gap-16">
            {/* Card 1 */}
            <div
              className="bg-white p-4 w-full sm:w-80 md:w-80 flex flex-col items-center md:items-start duration-300"
              onClick={() => navigate("/services/solar-panel")}
            >
              <div className="h-32 w-32 md:h-40 md:w-40">
                <img
                  src="/solar-panel-closeup.png"
                  alt="Solar panels"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="mt-4 text-center md:text-left">
                <h3 className="text-xl md:text-2xl font-bold">Solar Panels</h3>
                <p className="mt-1 text-slate-600 leading-relaxed text-sm">
                  High-efficiency panels for residential, commercial, and industrial projects.
                </p>
                <button className="mt-3 inline-flex items-center text-green-700 font-semibold text-sm group">
                  Learn More
                  <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">
                    →
                  </span>
                </button>
              </div>
            </div>

            {/* Card 2 */}
            <div
              className="bg-white p-4 w-full sm:w-80 md:w-80 flex flex-col items-center md:items-start duration-300"
              onClick={() => navigate("/services/solar-e-vehicle")}
            >
              <div className="h-32 w-32 md:h-40 md:w-40">
                <img
                  src="/solar-powered-scooter.png"
                  alt="EV scooter"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="mt-4 text-center md:text-left">
                <h3 className="text-xl md:text-2xl font-bold">EV Vehicles & Services</h3>
                <p className="mt-1 text-slate-600 leading-relaxed text-sm">
                  Electric vehicle solutions with charging infrastructure and maintenance.
                </p>
                <button className="mt-3 inline-flex items-center text-green-700 font-semibold text-sm group">
                  Learn More
                  <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">
                    →
                  </span>
                </button>
              </div>
            </div>

            {/* Card 3 */}
            <div
              className="bg-white p-4 w-full sm:w-80 md:w-80 flex flex-col items-center md:items-start duration-300"
              onClick={() => navigate("/services/energy-storage-systems")}
            >
              <div className="h-32 w-32 md:h-40 md:w-40">
                <img
                  src="/solar-battery-pack.png"
                  alt="Battery storage"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="mt-4 text-center md:text-left">
                <h3 className="text-xl md:text-2xl font-bold">Energy Storage System</h3>
                <p className="mt-1 text-slate-600 leading-relaxed text-sm">
                  Advanced batteries for uninterrupted, eco-friendly energy.
                </p>
                <button className="mt-3 inline-flex items-center text-green-700 font-semibold text-sm group">
                  Learn More
                  <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">
                    →
                  </span>
                </button>
              </div>
            </div>

            {/* Card 4 */}
            <div
              className="bg-white p-4 w-full sm:w-80 md:w-80 flex flex-col items-center md:items-start duration-300"
              onClick={() => navigate("/services/solar-inverter")}
            >
              <div className="h-32 w-32 md:h-40 md:w-40">
                <img
                  src="/solar-battery-inverter.png"
                  alt="Inverter"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="mt-4 text-center md:text-left">
                <h3 className="text-xl md:text-2xl font-bold">Inverters</h3>
                <p className="mt-1 text-slate-600 leading-relaxed text-sm">
                  Reliable solar inverters ensuring optimized power conversion.
                </p>
                <button className="mt-3 inline-flex items-center text-green-700 font-semibold text-sm group">
                  Learn More
                  <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">
                    →
                  </span>
                </button>
              </div>
            </div>

            {/* Card 5 */}
            <div
              className="bg-white p-4 w-full sm:w-80 md:w-80 flex flex-col items-center md:items-start duration-300"
              onClick={() => navigate("/services/solar-epc-services")}
            >
              <div className="h-32 w-32 md:h-40 md:w-40">
                <img
                  src="/solar-home-installation.png"
                  alt="Solar EPC project"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="mt-4 text-center md:text-left">
                <h3 className="text-xl md:text-2xl font-bold">Solar EPC Projects</h3>
                <p className="mt-1 text-slate-600 leading-relaxed text-sm">
                  End-to-end turnkey solutions from design, procurement, installation, to commissioning.
                </p>
                <button className="mt-3 inline-flex items-center text-green-700 font-semibold text-sm group">
                  Learn More
                  <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">
                    →
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="bg-brand-dark-blue py-16 md:py-24">
        <div className="px-4 md:px-8 text-center ml-10">
          <h2 className="text-3xl md:text-6xl tracking-tight text-slate-900 text-white">
            The Problem We Solve
          </h2>
          <p className="mt-4 text-slate-600 max-w-2xl mx-auto text-white">
            Communities, businesses, and homeowners face growing challenges in adopting
            sustainable energy and modern lifestyle solutions. Kyra Green Energy addresses
            these key issues:
          </p>

          <div className="mt-12 flex flex-wrap justify-center gap-12">

            <div className="  p-6 text-left">
              <div className="">
                <img src="/energy-cost-savings.png" alt="High Energy Costs" className="h-full w-100 object-cover" />
              </div>
              <h3 className="mt-4 text-2xl font-bold text-white">High Energy Costs &<br /> Inefficiencies</h3>
              <p className="mt-2 text-sm leading-relaxed text-white">
                Reduce costs with clean, reliable power.
              </p>
              <button
                type="button"
                className="mt-3 inline-flex items-center text-green-700 font-semibold text-xl"
              >
                Learn More
                <img src="/Icon-arrow.png" alt="arrow" className="ml-2 w-8 h-8" />
              </button>
            </div>

            <div className="  p-6 text-left">
              <div className="">
                <img src="/solar-panel-field.png" alt="Limited Access to Renewable Energy" className="h-full w-full object-cover" />
              </div>
              <h3 className="mt-4 text-xl font-bold  text-white">Limited Access to Renewable <br />Energy</h3>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed text-white">
                Easy adoption with quality solar and ESS systems.
              </p>
              <button
                type="button"
                className="mt-3 inline-flex items-center text-green-700 font-semibold text-xl"
              >
                Learn More
                <img src="/Icon-arrow.png" alt="arrow" className="ml-2 w-8 h-8" />
              </button>
            </div>

            <div className="  p-6 text-left">
              <div className="">
                <img src="/electric-scooter-ev.png" alt="EV Charging" className="h-full w-full object-cover" />
              </div>
              <h3 className="mt-4 text-xl font-bold  text-white">EV Charging & Maintenance <br />Challenges</h3>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed text-white">
                Hassle-free EV solutions and service support.
              </p>
              <button
                type="button"
                className="mt-3 inline-flex items-center text-green-700 font-semibold text-xl"
              >
                Learn More
                <img src="/Icon-arrow.png" alt="arrow" className="ml-2 w-8 h-8" />
              </button>


            </div>

            <div className="  p-6 text-left">
              <div className="">
                <img src="/solar-engineer-installation.png" alt="Fragmented Community Spaces" className="h-full w-full object-cover" />
              </div>
              <h3 className="mt-4 text-xl font-bold  text-white">Fragmented Community <br />Spaces</h3>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed text-white">
                Kyra Food Street hubs combine sustainability, food, and recreation.
              </p>
              <button
                type="button"
                className="mt-3 inline-flex items-center text-green-700 font-semibold text-xl"
              >
                Learn More
                <img src="/Icon-arrow.png" alt="arrow" className="ml-2 w-8 h-8" />
              </button>
            </div>

            <div className="  p-6 text-left">
              <div className="">
                <img src="/renewable-energy-guidance.png" alt="Lack of Expert Guidance" className="h-full w-full object-cover" />
              </div>
              <h3 className="mt-4 text-xl font-bold  text-white">Lack of Expert Guidance</h3>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed text-white">
                Our team provides full support from design to maintenance.
              </p>
              <button
                type="button"
                className="mt-3 inline-flex items-center text-green-700 font-semibold text-xl"
              >
                Learn More
                <img src="/Icon-arrow.png" alt="arrow" className="ml-2 w-8 h-8" />
              </button>
            </div>

          </div>
        </div>
      </section>


      <section className="bg-white md:py-20 md:my-10 py-20">
        <div className="px-4 md:px-8 lg:px-20 max-w-full lg:max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12">

            {/* Left content */}
            <div className="text-center lg:text-left flex-1">
              <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-slate-900">
                Why Choose Us
              </h2>

              <ul className="mt-8 list-disc pl-6 space-y-4 text-lg md:text-lg text-slate-700">
                <li>Expert Turnkey EPC Services</li>
                <li>Integrated Solar, EV, ESS & Lifestyle Hubs</li>
                <li>Eco-Friendly & Cost-Efficient Solutions</li>
                <li>Customer-Centric Approach</li>
              </ul>
            </div>

            {/* Right card */}
            <div className="flex justify-center lg:justify-end flex-1 w-full">
              <div className="rounded-3xl bg-brand-dark text-white px-20 py-20 md:px-62 md:py-20 w-full max-w-4xl lg:max-w-5xl shadow-lg text-left">
                <div className="text-2xl md:text-5xl">No.1</div>
                <p className="mt-4 text-lg md:text-xl text-slate-200">
                  in Sustainable Energy Solutions
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>



      <section className="py-12 md:py-16 bg-[#f5f7fa]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <h3 className="text-center text-brand-green font-bold text-4xl md:text-5xl">
            Pricing Section
          </h3>

          <p className="text-center text-gray-900 mt-3 font-semibold">
            Complete Solar Kit Includes:
          </p>

          <div className="mt-4 flex flex-col md:flex-row items-center justify-center gap-6 text-base">
            {[
              "720W Solar Panels – 9 units",
              "6kW Solar Inverter",
              "51.2V Lithium Battery (~5kW)",
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-brand-green"></span>
                <span className="text-gray-800">{item}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col md:flex-row items-center justify-center gap-16">
            <div className="bg-gradient-to-b from-gray-50 to-gray-100 rounded-xl 
  border-l-1 border-r-1 border-b-1 border-gray-200 
  border-t-8 border-brand-green 
  shadow-lg hover:shadow-2xl hover:-translate-y-0.5 
  transition-shadow transition-transform 
  p-8 md:p-10 w-full max-w-sm min-h-[350px] 
  flex flex-col justify-center items-start text-left">
              <h4 className="text-xl md:text-2xl font-bold text-brand-green">Buyer Type</h4>
              <hr className="mt-2 border-gray-300 w-full" />
              <div className="mt-8 space-y-6 text-gray-900 font-semibold text-lg md:text-xl">
                <p>Quantity</p>
                <p>Price (Excl. GST)</p>
                <p>Notes</p>
              </div>
            </div>


            <div className="bg-gradient-to-b from-gray-50 to-gray-100 rounded-2xl border border-gray-200 shadow-lg hover:shadow-2xl hover:-translate-y-0.5 transition-shadow transition-transform p-8 md:p-10 max-w-sm min-h-[350px] flex flex-col justify-center items-center text-center">
              <h4 className="text-xl md:text-2xl font-bold text-brand-green">Distributor</h4>
              <hr className="mt-2 border-gray-300 w-full" />
              <div className="mt-8 space-y-6 text-gray-900 font-semibold text-lg md:text-xl">
                <p>10 sets</p>
                <p className="text-xl md:text-xl text-gray-900">
                  ₹2,00,000 <span className="text-base md:text-lg font-normal">per set<br />+ GST</span>
                </p>
                <p className="text-gray-800">Bulk purchase offer</p>
              </div>
            </div>

            {/* Dealer */}
            <div className="bg-gradient-to-b from-gray-50 to-gray-100 rounded-2xl border border-gray-200 shadow-lg hover:shadow-2xl hover:-translate-y-0.5 transition-shadow transition-transform p-8 md:p-10 max-w-sm min-h-[350px] flex flex-col justify-center items-center text-center">
              <h4 className="text-xl md:text-2xl font-bold text-brand-green">Dealer</h4>
              <hr className="mt-2 border-gray-300 w-full" />
              <div className="mt-8 space-y-6 text-gray-900 font-semibold text-lg md:text-xl">
                <p>3 sets</p>
                <p className="text-xl md:text-xl text-gray-900">
                  ₹2,00,000 <span className="text-base md:text-lg font-normal">per set<br />+ GST</span>
                </p>
                <p className="text-gray-800">Smaller lot option</p>
              </div>
            </div>
          </div>
        </div>
      </section>



      <Faq type="home" />

      <section className="bg-brand-dark py-12 md:py-20">
        <div className="max-w-[1400px] mx-auto px-4 md:px-12">
          <h3 className="text-white text-3xl md:text-5xl text-center mb-10 md:mb-14 leading-snug">
            Happy Customers, <br /> Happy World
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">

            <div className="bg-brand-light-dark rounded-xl p-6 md:p-8 text-white hover:-translate-y-1 hover:shadow-2xl transition">
              <div className="mb-3 text-yellow-400 text-lg md:text-xl">★★★★★</div>
              <p className="font-semibold text-lg md:text-xl mb-2">
                Highly Professional And Efficient.
              </p>
              <p className="text-sm md:text-base text-gray-200 mb-4 leading-relaxed">
                Kyra Green Energy transformed our commercial rooftop into a reliable solar power system.
                The entire process was seamless, highly professional, and efficient.
              </p>
              <span className="text-sm font-semibold text-brand-green">
                Rahul S., Business Owner
              </span>
            </div>

            <div className="bg-brand-light-dark rounded-xl p-6 md:p-8 text-white hover:-translate-y-1 hover:shadow-2xl transition">
              <div className="mb-3 text-yellow-400 text-lg md:text-xl">★★★★★</div>
              <p className="font-semibold text-lg md:text-xl mb-2">
                Energy Costs Have Dropped Drastically
              </p>
              <p className="text-sm md:text-base text-gray-200 mb-4 leading-relaxed">
                Our home energy costs have reduced significantly. The Kyra team guided us through solar,
                ESS, and inverter selection, ensuring everything worked perfectly together.
              </p>
              <span className="text-sm font-semibold text-brand-green">
                Priya K., Residential Customer
              </span>
            </div>

            <div className="bg-brand-light-dark rounded-xl p-6 md:p-8 text-white hover:-translate-y-1 hover:shadow-2xl transition">
              <div className="mb-3 text-yellow-400 text-lg md:text-xl">★★★★★</div>
              <p className="font-semibold text-lg md:text-xl mb-2">
                Excellent Service!
              </p>
              <p className="text-sm md:text-base text-gray-200 mb-4 leading-relaxed">
                Kyra Food Street and the solar initiatives created a sustainable, engaging hub for our
                community. We’re truly impressed with the excellent service provided.
              </p>
              <span className="text-sm font-semibold text-brand-green">
                Anil M., Community Leader
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
